import type { Card } from '../../shared/doc.js';
import { assetUrl } from '../api.js';

export function ImageCard({ card }: { card: Extract<Card, { kind: 'image' }> }) {
  const src = card.assetId ? assetUrl(card.assetId, 640) : card.thumbAssetId ? assetUrl(card.thumbAssetId) : null;
  const ratio = card.width && card.height ? `${card.width} / ${card.height}` : undefined;
  return (
    <figure className="image-card">
      {src ? <img src={src} alt={card.caption || 'Image'} draggable={false} style={{ aspectRatio: ratio }} /> : <div className="image-missing">Image unavailable</div>}
      {(card.caption || card.credit) && (
        <figcaption>
          {card.caption}
          {card.credit && <small> · {card.credit}</small>}
        </figcaption>
      )}
    </figure>
  );
}
